import(/* webpackMode: "eager", webpackExports: ["SetTranslationData"] */ "/home/liamto-webqam/www/apps/front/src/i18n/SetTranslationData.tsx");
